/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19.104 4.43C16.846 3.45 14.439 3 11.956 3c-2.483 0-4.89.451-7.147 1.43-.677.3-1.129.978-1.129 1.655v5.492c0 4.063 2.558 7.598 6.395 8.953l.828.3a3.6 3.6 0 0 0 2.182 0l.827-.3a9.679 9.679 0 0 0 6.395-8.953V6.085a2.104 2.104 0 0 0-1.203-1.656Z"
})), "0 0 24 24", "Insurance");